export default "__VITE_ASSET__Fq_8mq2N__"